import { render } from "./LottieExample.vue?vue&type=template&id=20e89f36&scoped=true"
import script from "./LottieExample.vue?vue&type=script&lang=js"
export * from "./LottieExample.vue?vue&type=script&lang=js"

import "./LottieExample.vue?vue&type=style&index=0&id=20e89f36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20e89f36"

export default script